import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * JavaScript stand-in for the Material UI v4 `Hidden` component (removed in v7).
 * Like the v4 default ("js") implementation it renders no wrapper element and
 * does not mount the children at all when they are hidden, which matters for
 * portaled children such as a temporary Drawer.
 */
export default function Hidden({ mdUp = false, mdDown = false, children }) {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  if (mdUp && isMdUp) return null;
  if (mdDown && !isMdUp) return null;
  return children;
}
